/**
 * Known empty defaults for the Real Cookie Banner Template fields
 */ class KnownEmptyDefaults {
    /** Known empty default for the Quill Editor field. */ static QUILL_KNOWN_EMPTY = "<p><br></p>";
}
export { KnownEmptyDefaults };
